/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import './IntradayRefreshSpinner.scss';

import React from 'react';

const IntradayRefreshSpinner = () => (
  <div className="intraday-refresh-spinner" />
);

export default IntradayRefreshSpinner;
